export default __webpack_public_path__ + "static/media/0.b3997098.mp3";